// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dGeocoding$dTypes$dStreetAddressWithApartment from "../Restaumatic.Geocoding.Types.StreetAddressWithApartment/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const isIosReviewModeIsSymbol = {reflectSymbol: () => "isIosReviewMode"};
const isQrWaiterOrderIsSymbol = {reflectSymbol: () => "isQrWaiterOrder"};
const restaurantIdIsSymbol = {reflectSymbol: () => "restaurantId"};
const GetOrderingAvailabilityRequestIsSymbol = {reflectSymbol: () => "GetOrderingAvailabilityRequest"};
const decodeRecordCons = /* #__PURE__ */ Unscramble.decodeRecordCons(restaurantIdIsSymbol)(Unscramble.decodeInt1);
const emailIsSymbol = {reflectSymbol: () => "email"};
const phoneIsSymbol = {reflectSymbol: () => "phone"};
const streetAddressIsSymbol = {reflectSymbol: () => "streetAddress"};
const ClaimFODRequestIsSymbol = {reflectSymbol: () => "ClaimFODRequest"};
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const encodeWithOptionsOther1 = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const encodeWithOptionsOther2 = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode};
const decodeWithOptionsOther1 = {decodeWithOptions: v => Foreign$dGeneric$dClass.booleanDecode.decode};
const decodeWithOptionsOther2 = {decodeWithOptions: v => Foreign$dGeneric$dClass.readString};
const GetOrderingAvailabilityRequest = x => x;
const ClaimFODRequest = x => x;
const toFillFormTypeGetOrdering = {fillFormDataType: v => "unknown"};
const toFillFormTypeClaimFODReq = {fillFormDataType: v => "unknown"};
const rPCSitesGetOrderingAvaila = {};
const rPCSitesClaimFODRequestBo = {};
const rPCMethodNameGetOrderingA = {rpcMethodName: v => "GetOrderingAvailabilityRequest"};
const rPCMethodNameClaimFODRequ = {rpcMethodName: v => "ClaimFODRequest"};
const newtypeGetOrderingAvailab = {Coercible0: () => {}};
const newtypeClaimFODRequest_ = {Coercible0: () => {}};
const hasFieldGetOrderingAvaila = dictHasField => dictHasField;
const hasFieldClaimFODRequest = dictHasField => dictHasField;
const eqGetOrderingAvailability = {eq: x => y => x.isIosReviewMode === y.isIosReviewMode && x.isQrWaiterOrder === y.isQrWaiterOrder && x.restaurantId === y.restaurantId};
const eqClaimFODRequest = {
  eq: x => y => x.email === y.email && x.phone === y.phone && x.restaurantId === y.restaurantId && (() => {
    if (x.streetAddress.tag === "Nothing") { return y.streetAddress.tag === "Nothing"; }
    if (x.streetAddress.tag === "Just") {
      if (y.streetAddress.tag === "Just") {
        return (() => {
          if (x.streetAddress._1.apartmentNumber.tag === "Nothing") { return y.streetAddress._1.apartmentNumber.tag === "Nothing"; }
          if (x.streetAddress._1.apartmentNumber.tag === "Just") {
            if (y.streetAddress._1.apartmentNumber.tag === "Just") { return x.streetAddress._1.apartmentNumber._1 === y.streetAddress._1.apartmentNumber._1; }
            return false;
          }
          return false;
        })() && x.streetAddress._1.city === y.streetAddress._1.city && x.streetAddress._1.street === y.streetAddress._1.street && x.streetAddress._1.streetNumber === y.streetAddress._1.streetNumber;
      }
      return false;
    }
    return false;
  })()
};
const genericGetOrderingAvailabilityRequest = {to: x => x, from: x => x};
const showGetOrderingAvailabilityRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          if (v.isIosReviewMode) {
            if (v.isQrWaiterOrder) { return "{ isIosReviewMode: true, isQrWaiterOrder: true, restaurantId: " + Data$dShow.showIntImpl(v.restaurantId) + " }"; }
            return "{ isIosReviewMode: true, isQrWaiterOrder: false, restaurantId: " + Data$dShow.showIntImpl(v.restaurantId) + " }";
          }
          if (v.isQrWaiterOrder) { return "{ isIosReviewMode: false, isQrWaiterOrder: true, restaurantId: " + Data$dShow.showIntImpl(v.restaurantId) + " }"; }
          return "{ isIosReviewMode: false, isQrWaiterOrder: false, restaurantId: " + Data$dShow.showIntImpl(v.restaurantId) + " }";
        })()
      ]
    })(GetOrderingAvailabilityRequestIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeGetOrderingAvailabilityRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(isIosReviewModeIsSymbol)(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons(isQrWaiterOrderIsSymbol)(Unscramble.decodeBoolean1)(decodeRecordCons(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericClaimFODRequest = {to: x => x, from: x => x};
const showClaimFODRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ email: " + Data$dShow.showStringImpl(v.email) + ", phone: " + Data$dShow.showStringImpl(v.phone) + ", restaurantId: " + Data$dShow.showIntImpl(v.restaurantId) + (() => {
          if (v.streetAddress.tag === "Just") {
            return ", streetAddress: (Just " + Restaumatic$dGeocoding$dTypes$dStreetAddressWithApartment.showStreetAddressWithApartment.show(v.streetAddress._1) + ") ";
          }
          if (v.streetAddress.tag === "Nothing") { return ", streetAddress: Nothing "; }
          $runtime.fail();
        })() + "}"
      ]
    })(ClaimFODRequestIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeClaimFODRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(emailIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(phoneIsSymbol)(Unscramble.decodeString1)(decodeRecordCons(Unscramble.decodeRecordCons(streetAddressIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dGeocoding$dTypes$dStreetAddressWithApartment.unscrambleDecodeStreetAddressWithApartment))(Unscramble.decodeRecordNil)))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeGetOrderingAvailabilityRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericGetOrderingAvailabilityRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(GetOrderingAvailabilityRequestIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(restaurantIdIsSymbol)(encodeWithOptionsOther))(isQrWaiterOrderIsSymbol)(encodeWithOptionsOther1))(isIosReviewModeIsSymbol)(encodeWithOptionsOther1);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeClaimFODRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericClaimFODRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ClaimFODRequestIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(streetAddressIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dGeocoding$dTypes$dStreetAddressWithApartment.encodeStreetAddressWithApartment.encode(v2._1); }
        $runtime.fail();
      }
    }))(restaurantIdIsSymbol)(encodeWithOptionsOther))(phoneIsSymbol)(encodeWithOptionsOther2))(emailIsSymbol)(encodeWithOptionsOther2);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeGetOrderingAvailabilityRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericGetOrderingAvailabilityRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(GetOrderingAvailabilityRequestIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(restaurantIdIsSymbol)(decodeWithOptionsOther)())(isQrWaiterOrderIsSymbol)(decodeWithOptionsOther1)())(isIosReviewModeIsSymbol)(decodeWithOptionsOther1)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeClaimFODRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericClaimFODRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ClaimFODRequestIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(streetAddressIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dGeocoding$dTypes$dStreetAddressWithApartment.decodeStreetAddressWithApartment.decode)
  })())(restaurantIdIsSymbol)(decodeWithOptionsOther)())(phoneIsSymbol)(decodeWithOptionsOther2)())(emailIsSymbol)(decodeWithOptionsOther2)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  ClaimFODRequest,
  ClaimFODRequestIsSymbol,
  GetOrderingAvailabilityRequest,
  GetOrderingAvailabilityRequestIsSymbol,
  decodeClaimFODRequest,
  decodeGetOrderingAvailabilityRequest,
  decodeRecordCons,
  decodeWithOptionsOther,
  decodeWithOptionsOther1,
  decodeWithOptionsOther2,
  emailIsSymbol,
  encodeClaimFODRequest,
  encodeGetOrderingAvailabilityRequest,
  encodeWithOptionsOther,
  encodeWithOptionsOther1,
  encodeWithOptionsOther2,
  eqClaimFODRequest,
  eqGetOrderingAvailability,
  genericClaimFODRequest,
  genericGetOrderingAvailabilityRequest,
  hasFieldClaimFODRequest,
  hasFieldGetOrderingAvaila,
  isIosReviewModeIsSymbol,
  isQrWaiterOrderIsSymbol,
  newtypeClaimFODRequest_,
  newtypeGetOrderingAvailab,
  phoneIsSymbol,
  rPCMethodNameClaimFODRequ,
  rPCMethodNameGetOrderingA,
  rPCSitesClaimFODRequestBo,
  rPCSitesGetOrderingAvaila,
  restaurantIdIsSymbol,
  showClaimFODRequest,
  showGetOrderingAvailabilityRequest,
  streetAddressIsSymbol,
  toFillFormTypeClaimFODReq,
  toFillFormTypeGetOrdering,
  unscrambleDecodeClaimFODRequest,
  unscrambleDecodeGetOrderingAvailabilityRequest
};
